export const getStripePublishableKey = () => window.globalConfig.STRIPE_PUBLISHABLE_KEY;
export const getSubscriptionPlans = () => window.globalConfig.SUBSCRIPTION_PLANS;
export const getGrowBundle = () => window.globalConfig.GROW_BUNDLE;
export const getSupportBundleSeparate = () => window.globalConfig.SUPPORT_BUNDLE_SEPARATE;



// WEBPACK FOOTER //
// ./app/javascript/common/utils/config.js